import * as React from "react";
import styled, { css } from "styled-components";

import { colors } from "../../common/utils/style";
import StyledInput, { StyledInputProps } from "./StyledInput";
import Hover, { HoverChildrenFunc } from "./Hover";
import Icon from "./Icon";

type Props = StyledInputProps;

interface State {
  currentValue: string;
  isEditing: boolean;
}

class TogglableStyledInput extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      currentValue: props.value,
      isEditing: false,
    };
  }

  public componentWillReceiveProps(nextProps: Props) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        currentValue: nextProps.value,
      });
    }
  }

  public onChange = (newValue: string) => {
    this.setState({
      currentValue: newValue,
    });
  };

  public onStartEditing = () => {
    this.setState({ isEditing: true });
  };

  public onFinishEditing = () => {
    this.setState({ isEditing: false });
    if (this.props.value !== this.state.currentValue) {
      this.props.onChange(this.state.currentValue);
    }
  };

  public render() {
    return <Hover>{this.renderWithHover}</Hover>;
  }

  private renderWithHover: HoverChildrenFunc = ({ isHovered, ref }) => {
    const { editable, maxLength } = this.props;
    const { currentValue, isEditing } = this.state;
    return (
      <Wrapper innerRef={ref}>
        {editable && (isHovered || isEditing) && <EditIcon name="wt-icon-pencil" />}
        <Input
          {...this.props as any}
          value={currentValue}
          onChange={this.onChange}
          onFocus={this.onStartEditing}
          onBlur={this.onFinishEditing}
        />
        {editable &&
          (isEditing || isHovered) &&
          maxLength && (
            <TextCounter>
              {currentValue.length} / {maxLength}
            </TextCounter>
          )}
      </Wrapper>
    );
  };
}

const Wrapper = styled.div`
  position: relative;
`;

const EditIcon = styled(Icon)`
  position: absolute;
  right: 0px;
  top: -15px;
  color: rgba(0, 0, 0, 0.4);
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.6;
  }
`;

const Input = styled(StyledInput)`
  ${(props: { editable: boolean }) =>
    props.editable
      ? css`
          &:hover:not(:focus) {
            color: ${colors.lightTextGray};
          }
        `
      : ""};
`;

const TextCounter = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  font-weight: 400;
  font-size: 11px;
  line-height: 1;
  text-align: right;
  color: rgba(0, 0, 0, 0.27);
`;

export default TogglableStyledInput;



// WEBPACK FOOTER //
// ./frontend/src/common/components/TogglableStyledInput.tsx